<script lang="ts" setup>
import { useScroll } from '@vueuse/core'
import { computed, inject } from 'vue'
import { useGotoBack } from '@/composables'

withDefaults(
  defineProps<{
    opacity?: boolean
    scale?: boolean
    title?: string
  }>(),
  {
    opacity: false,
    scale: false,
  },
)

const gotoBack = useGotoBack()

const containerRef = inject<HTMLElement>('containerRef', document.body)
const theme = inject<{ background: string }>('theme', { background: 'white' })

const { y } = useScroll(containerRef)
const max = 300
const opacityStyle = computed(() => {
  const opacity = Math.min(y.value / max, 1)
  return `background-color: rgba(255, 255, 255, ${opacity});`
})
</script>

<template>
  <div
    class="fixed-navbar flex items-center z-10"
    :style="(opacity ? opacityStyle : '') + (y !== 0 ? `background: ${theme.background}` : '')"
  >
    <div class="p-2" @click="gotoBack()">
      <i-icon-park-outline-left
        class="transition-all duration-200"
        :class="(scale && y !== 0) ? 'w-4 h-4 text-n-text-3' : 'w-7 h-7'"
      />
    </div>
    <slot>
      <p v-show="title && scale && y !== 0" class="text-n-text-3">
        {{ title }}
      </p>
    </slot>
  </div>
</template>

<style scoped>
.fixed-navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
}

/* stylelint-disable unit-case */
@media (min-width: 768px) {
  .fixed-navbar {
    left: 50%;
    right: auto;
    width: 750PX;
    max-width: 750PX;
    transform: translateX(-50%);
  }
}
</style>
